import React, { useEffect } from 'react'
import { Redirect, Route, useLocation, } from 'react-router-dom';

import useAuth from '../auth/UseAuth';
import { settings } from '../helpers/main';

export default function PrivateRouter({ component: Component, ...rest }) {
    //#region variables
    const auth = useAuth();
    const location = useLocation();
    // const [isUserLoged, setIsUserLoged] = useState(auth?.isLoged({ subMethod: 'PrivateRouter' })?.result);
    //#endregion variables

    //#region methods
    // const getData = () => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'getData';
    //     try {
    //         if (isUndNullEmp({ data: auth, subMethod: currentMethod })?.result ||
    //             isUndNullEmp({ data: auth?.user, subMethod: currentMethod })?.result ||
    //             isUndNullEmp({ data: auth?.user?.token, subMethod: currentMethod })?.result ||
    //             isUndNull({ data: auth?.user?.token?.id, subMethod: currentMethod })?.result ||
    //             isUndNullEmp({ data: auth?.user?.token?.token, subMethod: currentMethod })?.result ||
    //             isUndNullEmp({ data: auth?.user?.role, subMethod: currentMethod })?.result ||
    //             isUndNullEmp({ data: auth?.user?.role?.id, subMethod: currentMethod })?.result) {
    //             setIsUserLoged(false);
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //         sendMessage({ msgType: response?.msgType, msgText: response?.msgText, timer: 0, confirmButton: true, timerProgressBar: false });
    //     }
    // }

    useEffect(() => {
        // getData();
        // const a = location?.pathname;
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Route {...rest}>
            {/* {auth?.isLoged({ subMethod: 'PrivateRouter' }) ? (<Component />) : (<Redirect to={{ pathname: '/login', state: { from: location, }, }} />)} */}
            {/* {isUserLoged ? (<Component />) : (<Redirect to={{ pathname: settings?.backend?.urls?.login, state: { from: location?.pathname, } }} />)} */}
            {auth?.isLoged({ subMethod: 'PrivateRouter' })?.result ? (<Component />) : (<Redirect to={{ pathname: settings?.backend?.urls?.login, state: { from: location?.pathname, } }} />)}
        </Route>
    )
}